module.exports = __webpack_public_path__ + "static/media/verifiedGray.bd2394ba.svg";